import AdicionarEstagioModal from "../../modals/AdicionarEstagioModal"
import GerenciarEventosEstagioModal from "../../modals/GerenciarEventosEstagioModal"
import Links from "@/shared/constants/navegacao"
import ModalExcluir from "@/shared/components/modals/ModalExcluir"
import { CursoService } from "@/modules/structure/curso/curso.service"
import { DataAmigavel } from "@/shared/utils/datas"
import { ReadCursoDto, ReadEstagiarioEstagioDto, ReadInstituicaoEnsinoDto } from "@/api.types"
import { Fragment } from "react/jsx-runtime"
import { InstituicaoEnsinoService } from "@/modules/structure/instituicoes/instituicao.service"
import { Link } from "react-router-dom"
import { PersonProfilesFormMethods } from "./profile.types"
import { TipoLotacaoEstagioList, TipoLotacaoList } from "@/shared/constants/enumlist"
import { exportToDoc } from "@/shared/components/exportToDoc"
import { toast } from "react-toastify"
import { useFieldArray } from "react-hook-form"
import { useState, useEffect } from "react"
import { LotacaoService } from "@/modules/business/lotacoes/lotacao.service"
import { ReadLotacaoDto } from "@/api.types"
import { SearchDtoLotacoes } from "@/shared/types/search.dto"

interface EstagiarioProfileProps {
  methods: PersonProfilesFormMethods
  podeVerEstagiario: boolean
}

export function EstagiarioProfile({ methods, podeVerEstagiario, }: EstagiarioProfileProps) {

  const estagiarioAtivo = methods.watch('estagiario.ativo')
  const estagiarioId = methods.watch('estagiario.id')
  const estagios = methods.watch('estagiario.estagios')

  const existeRegistro = !!estagiarioId
  const deveMostrarCampos = estagiarioAtivo || existeRegistro
  const camposDesabilitados = existeRegistro && !estagiarioAtivo

  const { append, remove } = useFieldArray({
    control: methods.control,
    name: 'estagiario.estagios',
    keyName: '_id',
  })

  if (!podeVerEstagiario) {
    return null
  }

  const cursoService = new CursoService();
  const instituicoesService = new InstituicaoEnsinoService();

  const [cursos, setCursos] = useState<ReadCursoDto[]>([]);
  const [instituicoes, setInstituicoes] = useState<ReadInstituicaoEnsinoDto[]>([]);

  const [idEstagioEdicao, setIdEstagioEdicao] = useState(0);
  const [indexEstagioRemover, setIndexEstagioRemover] = useState(-1);
  const [modalAdicionarEstagioShow, setModalAdicionarEstagioShow] = useState(false);
  const [modalExcluirEstagioShow, setModalExcluirEstagioShow] = useState(false);
  const [lotacoesAtuais, setLotacoesAtuais] = useState<ReadLotacaoDto[]>([]);
  const [modalEventoShow, setModalEventoShow] = useState(false);
  const [idEstagioEvento, setIdEstagioEvento] = useState(0);

  useEffect(() => {
    Promise.all([
      cursoService.findAll({ skip: 0, take: 1000 }),
      instituicoesService.Enumerate(),
    ])
      .then((res) => {
        setCursos(res[0][0]);
        setInstituicoes(res[1]);

      })
      .catch((error) => {
        toast.error(error.message || 'Erro ao carregar dados.');
      });
  }, []);

  useEffect(() => {
    if (estagiarioId) {
      const lotacaoService = new LotacaoService();
      const searchParams: SearchDtoLotacoes = {
        skip: 0,
        take: 9000,
        id_estagiario: estagiarioId,
      } as SearchDtoLotacoes;

      lotacaoService
        .Enumerate(searchParams)
        .then((result) => {
          setLotacoesAtuais(result[0]);
        })
        .catch((error) => {
          console.warn('Erro ao carregar lotações:', error);
        });
    }
  }, [estagiarioId]);

  const handleEditarEstagio = (index: number) => {
    setIdEstagioEdicao(index);
    setModalAdicionarEstagioShow(true);
  };

  const abrirModalAdicionarEstagio = () => {
    setIdEstagioEdicao(-1); // Reseta o valor pra indicar adição de novo estágio
    setModalAdicionarEstagioShow(true);
  };

  const handleExcluirEstagio = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (indexEstagioRemover >= 0) remove(indexEstagioRemover);
    setModalExcluirEstagioShow(false);
  };

  const abrirModalEvento = (idEstagio: number) => {
    setIdEstagioEvento(idEstagio);
    setModalEventoShow(true);
  };

  return (
    <div className="card mb-3">
      <div className="card-header">
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="estagiario_ativo"
            {...methods.register("estagiario.ativo")}
          />
          <label className="form-check-label" htmlFor="estagiario_ativo">
            Habilitar Perfil de Estagiário(a)
          </label>
          <div className="float-end">
            <button
              type="button"
              className="btn btn-sm btn-outline-primary me-3"
              onClick={abrirModalAdicionarEstagio}
              title="Adicionar novo estágio"
              disabled={camposDesabilitados}
            >
              Adicionar Estágio
            </button>
            <Link
              to={`${Links.Folha_Frequencia_Index}/${methods.getValues("estagiario.id")}`}
              className="btn btn-sm btn-outline-success"
              title="Ver folhas de frequência"
              target="_blank"
            >
              Folhas de Frequência
            </Link>
          </div>
        </div>
      </div>

      {deveMostrarCampos && (
        <div className="card-body">
          <div className="mb-3">
            <Fragment>
              <>
                <table className="table table-sm table-bordered table-hover table-striped text-center">
                  <thead>
                    <tr>
                      <th>Tipo</th>
                      <th>Curso</th>
                      <th>Colação de Grau</th>
                      <th>Fim de Semana</th>
                      <th>Início do Estágio</th>
                      <th>Fim do Estágio</th>
                      <th>Desligamento</th>
                      <th>Ações</th>
                      <th>Registro</th>
                    </tr>
                  </thead>
                  <tbody>
                    {estagios &&
                      estagios.map((estagio, index) => {
                        let exibida = '';
                        if (estagio.data_colacao_grau) {
                          const [ano, mes] = String(estagio.data_colacao_grau).split('-');

                          const dataColacao = new Date(
                            new Date(Number(ano), Number(mes) - 1).toUTCString(),
                          );
                          exibida = dataColacao.toLocaleDateString('pt-BR', {
                            month: 'long',
                            year: 'numeric',
                          });
                        }

                        return (
                          <tr key={index}>
                            <td>
                              {
                                TipoLotacaoEstagioList.find(
                                  (a) => a.value == estagio.tipo_estagio,
                                )?.name
                              }
                            </td>
                            <td>
                              {cursos.find((a) => a.id == estagio.curso?.id)?.nome}
                            </td>
                            <td>{exibida}</td>
                            <td>{estagio.fim_semana ? 'Sim' : 'Não'}</td>
                            <td>{DataAmigavel(estagio.data_inicio_estagio)}</td>
                            <td>{DataAmigavel(estagio.data_fim_estagio)}</td>
                            <td>{DataAmigavel(estagio.desligamento)}</td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-sm me-2 mb-2"
                                onClick={() => exportToDoc(methods.getValues(), estagio)}
                                title="Termo de compromisso para esse estágio."
                                disabled={camposDesabilitados}
                              >
                                Termo
                              </button>
                              {estagio.id > 0 && (
                                <Link
                                  to={Links.Vinculos_Index + '?tipo=estagiario'}
                                  className="btn btn-sm btn-outline-success mb-2"
                                  title="Ir à página de lotação;"
                                >
                                  Vínculos
                                </Link>
                              )}
                              {estagio.id > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-info mb-2 ms-2"
                                  title="Gerenciar eventos (férias, folgas, abonos)"
                                  onClick={() => abrirModalEvento(estagio.id)}
                                  disabled={camposDesabilitados}
                                >
                                  Eventos
                                </button>
                              )}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-dark me-2 mb-2"
                                onClick={() => handleEditarEstagio(index)}
                                disabled={camposDesabilitados}
                              >
                                Editar
                              </button>
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm mb-2"
                                title="Remover esse estágio."
                                onClick={() => {
                                  setIndexEstagioRemover(index);
                                  setModalExcluirEstagioShow(true);
                                }}
                                disabled={camposDesabilitados}
                              >
                                Excluir
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </>

              {modalAdicionarEstagioShow && (
                <AdicionarEstagioModal
                  show={modalAdicionarEstagioShow}
                  handleHide={() => setModalAdicionarEstagioShow(false)}
                  cursos={cursos}
                  instituicoes={instituicoes}
                  initialData={
                    idEstagioEdicao >= 0
                      ? methods.getValues(`estagiario.estagios.${idEstagioEdicao}`)!
                      : ({} as ReadEstagiarioEstagioDto)
                  }
                  estagioIndex={idEstagioEdicao}
                  appendEstagio={append}
                  setValue={methods.setValue}
                  getValues={methods.getValues}
                />
              )}

              <ModalExcluir
                show={modalExcluirEstagioShow}
                handleExcluir={handleExcluirEstagio}
                handleHide={() => setModalExcluirEstagioShow(false)}
              />

              {modalEventoShow && idEstagioEvento > 0 && (
                <GerenciarEventosEstagioModal
                  show={modalEventoShow}
                  handleHide={() => {
                    setModalEventoShow(false);
                    setIdEstagioEvento(0);
                  }}
                  idEstagio={idEstagioEvento}
                />
              )}
            </Fragment>
          </div>

          <div className="mb-3 col-md-4">
            <label htmlFor="estagiario_anotacao" className="form-label">Anotações:</label>
            <input
              id="estagiario_anotacao"
              type="text"
              className="form-control"
              disabled={camposDesabilitados}
              {...methods.register('estagiario.anotacao')}
            />
          </div>

          {lotacoesAtuais.length > 0 && (
            <div className="mt-4">
              <table className="table table-sm table-bordered table-hover table-striped">
                <thead>
                  <tr>
                    <th>Tipo</th>
                    <th className="text-center">Início</th>
                    <th className="text-center">Término</th>
                    <th>Local</th>
                  </tr>
                </thead>
                <tbody>
                  {lotacoesAtuais.map((lotacao, index) => {
                    const local = lotacao.defensoria?.nome || lotacao.nucleo?.nome || lotacao.setor?.nome || '-';
                    return (
                      <tr key={index}>
                        <td>{TipoLotacaoList.find((a) => a.value === lotacao.tipo)?.name}</td>
                        <td className="text-center">{lotacao.data_inicial ? DataAmigavel(lotacao.data_inicial) : '-'}</td>
                        <td className="text-center">{lotacao.data_final ? DataAmigavel(lotacao.data_final) : '-'}</td>
                        <td>
                          {lotacao.id ? (<Link to={`${Links.Vinculos_Editar}/${lotacao.id}`} target="_blank" title="Editar lotação">
                            {local}
                          </Link>
                          ) : (
                            local
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
